import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppUtil } from 'src/app/core/utils/utils';
import { HomeService } from 'src/app/feature/user/services/home/home.service';
import { SearchService } from '../../services/search/search.service';
import { SharedService } from 'src/app/shared/services/shared/shared.service';
import { CommonService } from 'src/app/shared/services/common/common.service';
import { config } from 'src/assets/config/config';
import { Country } from 'src/app/shared/country.type';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  public helpfulLinksList: Array<any>;
  public serverError = false;
  private unsubscribe$ = new Subject();
  public navigation: any; 
  private currentLang: any;
  public countryId: any;

  constructor(
    public homeService: HomeService,
    public searchService: SearchService,
    private router: Router,
    private sharedService: SharedService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    const type = sessionStorage.getItem('userType');
    this.countryId = this.commonService.getCountryId();
    let userType = sessionStorage.getItem('userType');
    this.commonService.language$.subscribe(lang => {
      this.currentLang = lang
      if(userType)
      this.getHomeDataTask(this.currentLang, userType);
    })
    this.navigation = '/'+type;
    this.getHomeDataTask(this.currentLang, userType);
    this.searchService.emitUrlData({url : this.router.url });
  }

  navigateBack(): void {
		let userType = sessionStorage.getItem('userType');
    let region = sessionStorage.getItem('region');
    let country: Country = (window as any)['country'] ? (window as any)['country'] as Country : 'us';
    if(region === 'en-us'){
      const path = `/${region}/home`;
      this.router.navigate([path]);
    }
    else if(userType === 'Business'){
      const path = `/${region}/business`;
      this.router.navigate([path]);
    } else if(userType === 'Private') {
      const path = `/${region}/private`;
      this.router.navigate([path]);
    } else if(userType === 'NonCustomer') {
      const path = `/${region}/non-customer`;
      this.router.navigate([path]);
    }else if(userType === 'Customer') {
      
    } else if(config[country].defaultRedirectOnBootstrap !== "") {
      const path = `/${region}${config[country].defaultRedirectOnBootstrap}`;
      this.router.navigate([path]);
    }
	}
  navigateToFirstPage() {
    let region = sessionStorage.getItem('region')
		const path = `${region}`;
		this.router.navigate([path]);
  }
  /**
   * @description Method to get channelMap data from API
   */
   public getHomeDataTask (lang?: string, userType?: any): void {
    this.homeService.getHomeData(lang, userType)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((resp) => {
        if (resp) {
          this.helpfulLinksList = resp?.helpfulLinksList[0]?.Channel_List;
        }
      },
        (err) => {
          if (err?.error?.StatusCode === "500") {
            this.serverError = true;
          }
        });
  }

}
